module.exports = __webpack_public_path__ + "static/img/logo(4).9ace779.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo(4).png
// module id = jHHh
// module chunks = 41